export const handleDuplicateCabinet = async (
  cabinetToDuplicate,
  products,
  host,
  designId,
  updateDesignProducts,
  metadataBaseUrl
) => {

  let updatedProducts = [...products];
  // Add the duplicated cabinet to the products array
  updatedProducts.push(cabinetToDuplicate);

  // Update the design with the new products
  await updateDesignProducts(
    host,
    designId,
    updatedProducts,
    cabinetToDuplicate,
    metadataBaseUrl
  );
};
